import { gql } from '@apollo/client';

export const getDashboardChartStatsQuery = (breakdown: string, kpi: string) => gql`
    query clientBreakdownChartStats(
        $filters: StatsFilter!,
        $breakdown: StatsOrderByColumn!, 
        $kpi: StatsOrderByColumn!
    ) {
        stats(filters: $filters, orderBy: [{ column: $kpi, direction: DESC }, { column: $breakdown, direction: DESC }]) {
            items {
                kpi: ${kpi}
                breakdown: ${breakdown}
            }
        }
    }
`;
